import { FilePond, registerPlugin } from "react-filepond";
import React from "react";
import "./Home.css";
import "../utils/style.css";
import ParticlesBg from "particles-bg";
import { Container } from "@mui/material";
import NavMenu from "./Menu";
// Import FilePond styles
import "../utils/filepond.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import FilePondPluginFileMetadata from "filepond-plugin-file-metadata";
import FilePondPluginFilePoster from "filepond-plugin-file-poster";

// Import the plugin styles
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

// Register the plugin
registerPlugin(FilePondPluginFileEncode);
registerPlugin(FilePondPluginFilePoster);
registerPlugin(FilePondPluginFileMetadata);
registerPlugin(FilePondPluginFileRename);
registerPlugin(FilePondPluginImageTransform);
registerPlugin(FilePondPluginImageResize);
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
registerPlugin(FilePondPluginImageValidateSize);

// Our app
class UploadVideos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      from: "",
      subject: "",
      message: "",
      active: (props.locked && props.active) || false,
      value: props.value || "",
      error: props.error || "",
      label: props.label || "Label",
      petname: "",
    };
  }

  handleInit() {
    console.log("FilePond instance has initialised", this.pond);
  }

  render() {
    const { active, value, error, label } = this.state;
    const { predicted, locked } = this.props;
    const fieldClassName = `field ${
      (locked ? active : active || value) && "active"
    } ${locked && !active && "locked"}`;

    return (
      <>
        <NavMenu />
        <ParticlesBg type="circle" bg={true} />
        <Container className="container" maxWidth="sm">
          <p>
            <div className="App">
              {/* Pass FilePond properties as attributes */}
              <FilePond
                ref={(ref) => (this.pond = ref)}
                files={this.state.files}
                fileRenameFunction={(file) =>
                  new Promise((resolve) => {
                    resolve(window.prompt("Enter new filename", file.name));
                  })
                }
                allowFileEncode={true}
                allowAutoUpload={false}
                allowImageRename={true}
                allowImagePreview={true}
                allowMultiple={true}
                allowImageResize={false}
                allowFileMetadata={true}
                imageResizeTargetHeight="900"
                allowImageCrop={false}
                imageResizeMode="cover"
                maxFiles={15}
                imageResizeTargetWidth="1024"
                imageCropAspectRatio="1"
                server={{
                  process: (
                    fieldName,
                    file,
                    metadata,
                    load,
                    error,
                    progress,
                    abort
                  ) => {
                    // form control??
                    const formData = new FormData();
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open("POST", "/api/uploadvideo");

                    // Should call the progress method to update the progress to 100% before calling load
                    // Setting computable to false switches the loading indicator to infinite mode
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };

                    // Should call the load method when done and pass the returned server file id
                    // this server file id is then used later on when reverting or restoring a file
                    // so your server knows which file to return without exposing that info to the client
                    request.onload = function () {
                      if (request.status >= 200 && request.status < 300) {
                        // the load method accepts either a string (id) or an object
                        load(request.responseText);
                      } else {
                        // Can call the error method if something is wrong, should exit after
                        error("oh no");
                      }
                    };

                    request.send(formData);

                    // Should expose an abort method so the request can be cancelled
                    return {
                      abort: () => {
                        // This function is entered if the user has tapped the cancel button
                        request.abort();

                        // Let FilePond know the request has been cancelled
                        abort();
                      },
                    };
                    // set data
                  },
                }}
                oninit={() => this.handleInit()}
                onremovefile={(fs) => {
                  this.setState({ hasFile: fs && fs.length });
                }}
                onupdatefiles={(fileItems) => {
                  // Set current file objects to this.state
                  this.setState({
                    files: fileItems.map((fileItem) => fileItem.file),
                  });
                }}
              ></FilePond>
            </div>
            <div className={fieldClassName}>
              {active && value && predicted && predicted.includes(value) && (
                <p className="predicted">{predicted}</p>
              )}
              NOTE: Can only process .mp4 files. Need to convert .mov to .mp4
              <input
                id={2}
                label="Video Title"
                type="text"
                value={""}
                placeholder=""
                onChange={(e) => this.setState({ petname: e.target.value })}
                //onKeyPress={this.handleKeyPress.bind(this)}
                onFocus={() => !locked && this.setState({ active: true })}
                onBlur={() => !locked && this.setState({ active: false })}
              />
              <label htmlFor={1} className={error && "error"}>
                {error || ""}
              </label>
            </div>
          </p>
        </Container>
      </>
    );
  }
}
export default UploadVideos;
